import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trash, Trash2 } from "react-feather";
import { Button, Col, Input, Row } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import {
  getCrossByArticleBrand,
  removeCross,
  updateCross,
} from "services/api";
import { toast } from "react-toastify";

import { TableButton } from "components/TableButton";
import { Cut } from "components/Cut";
import { MySpinner } from "components/MySpinner";
import { AddCrossModal } from "features/Cross/AddCrossModal";
import { UpdateCrossModal } from "features/Cross/UpdateCrossModal";

import "./oem.scss";

export const Oem = ({ activeTab, article, brand, name }) => {
  const [searchArticle, setSearchArticle] = useState("");
  const [searchBrand, setSearchBrand] = useState("");
  const [crossFiltered, setCrossFiltered] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loadingCross, setLoadingCross] = useState(false);
  const [cross, setCross] = useState([]);
  const [analogueCode, setAnalogueCode] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [openModalUpdate, setOpenModalUpdate] = useState(false);

  const getAndSetCross = () => {
    setLoadingCross(true);
    getCrossByArticleBrand({
      article,
      brand: brand?.label,
    })
      .then((res) => {
        setCross(res[0].cross || []);
        setAnalogueCode(res[0].analogueCode?.id);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoadingCross(false));
  };

  const removeCrossHandler = (id = null) => {
    setLoadingCross(true);
    removeCross({ ids: id ? [id] : selected })
      .then(() => {
        toast.success("Кросс успешно удален");
        getAndSetCross();
        setSelected([]);
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
        setLoadingCross(false);
      });
  };

  const filterByArticleBrand = (item) => {
    if (!searchArticle && !searchBrand) {
      return true;
    }
    if (
      searchArticle &&
      item.article.toUpperCase().includes(searchArticle.toUpperCase())
    ) {
      return true;
    }
    if (
      searchBrand &&
      item.brand.toUpperCase().includes(searchBrand.toUpperCase())
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (activeTab === "3") {
      getAndSetCross();
    }
  }, [activeTab]);

  useEffect(() => {
    if (!cross.length) return;
    setCrossFiltered(cross.filter(filterByArticleBrand));
  }, [cross, searchArticle, searchBrand]);

  const tableCrossColumns = [
    {
      dataField: "brand",
      text: "Бренд",
      formatter: (cell, row) => cell.name,
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "article",
      text: "Артикул",
      formatter: (cell, row) => {
        return row.nomenclatureId ? (
          <Link
            to={`/reference/nomenclature?search=${cell}`}
            target="_blank"
          >
            {cell}
          </Link>
        ) : (
          <>{cell}</>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "name",
      text: "Наименование",
      formatter: (cell, row) => <Cut>{cell}</Cut>,
      headerStyle: (colum, colIndex) => {
        return { width: "40%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "remove",
      text: "",
      formatter: (cell, row) => <TableButton
        Icon={Trash}
        onClick={() => removeCrossHandler(row.id)}
      />,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
      footer: () => null,
    },
  ]

  const selectRow = {
    mode: "checkbox",
    bgColor: "#bfbfbf",
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelected((prev) => {
        if (!isSelect) {
          prev.splice(
            prev.findIndex((val) => val === row.id),
            1
          );
          return [...prev];
        }
        return [...prev, row.id];
      });
    },
    onSelectAll: (isSelect, rows, e) => {
      if (!isSelect) {
        setSelected([]);
      } else {
        setSelected(crossFiltered.map((val) => val.id));
      }
    },
  };

  const cloneNameHandler = () => {
    if (!name) {
      toast.error("Укажите наименование");
      return;
    }
    //setLoadingCross(true);
    // cloneName({
    //   ids: selected,
    //   name
    // })
    //   .then((res) => {
    //     getAndSetCross();
    //     toast.success("Наименования успешно записаны");
    //     setSelected([]);
    //   })
    //   .catch((e) => toast.error(e.response?.data?.message));
  }

  return (
    <>
      <div className="mb-3">
        {loadingCross && <MySpinner overlay />}
        <Row>
          <Col md={9} className="d-flex">
            <Button onClick={() => setOpenModal(true)} color="primary mr-2">
              Добавить
            </Button>
            {selected.length > 0 && <>
              <Button onClick={() => removeCrossHandler()} color="primary mr-2">
                <Trash2 size={15} /> Удалить
              </Button>
              <Button onClick={() => setOpenModalUpdate(true)} color="primary mr-2">
                <Trash2 size={15} /> Перенести в другой кросс
              </Button>
              <Button onClick={() => cloneNameHandler()} color="primary">
                Клонировать наименования
              </Button>
            </>}
          </Col>
        </Row>
      </div>
      <Row className="mb-1">
        <Col md={5}>
          <Input
            value={searchArticle}
            onChange={(e) => setSearchArticle(e.target.value)}
            placeholder="Артикул"
          />
        </Col>
        <Col md={5}>
          <Input
            value={searchBrand}
            onChange={(e) => setSearchBrand(e.target.value)}
            placeholder="Бренд"
          />
        </Col>
      </Row>

      <AddCrossModal
        article={article}
        brandId={brand?.value}
        cross={cross}
        analogueCode={analogueCode}
        setOpenModal={setOpenModal}
        openModal={openModal}
        getAndSetCross={getAndSetCross}
      />

      <UpdateCrossModal
        ids={selected}
        setSelected={setSelected}
        openModal={openModalUpdate}
        setOpenModal={setOpenModalUpdate}
        getAndSetCross={getAndSetCross}
      />

      <BootstrapTable
        wrapperClasses="cross p-0"
        keyField="id"
        data={crossFiltered}
        hover={true}
        columns={tableCrossColumns}
        bootstrap4
        bordered={false}
        selectRow={selectRow}
      />
    </>
  );
};
